import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { init } from '../../auth/handleTokens';
import { constants } from '../../constants';

const Historial = (props) => {
    const toggle = props.toggleSidebar ? '240px' : '10px';
    const [messages, setMessages] = useState([]);
    const [changeMessages, setChangeMessages] = useState(false);

    const getMessages =  async() => {
        try {
          const result = await init();
          if(!result) return window.location.href = '/login';
          const token = window.localStorage.getItem('at');
          const URL = constants.test_host + '/sms/gethistorymessages';
          const {data} = await axios.get(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
          setMessages(data.historyMessage);
          return
          
         } catch (error) {
            console.log(error)
         }
    }

    const refreshMessage = () => {
      setChangeMessages(!changeMessages);
    }

    const tableMessages = messages.map((item, index) =>
      <tr key={item._id}>
        <td>{index + 1}</td>
        <td style={{textAlign: 'justify'}}>{item.content}</td>
        <td style={{textAlign: 'justify'}}>{item.to}</td>
        <td style={{textAlign: 'justify'}}>{item.dateSend}</td>
      </tr>
    )
    
    useEffect(()=> {
        getMessages();
    }, [changeMessages])

    return (
      <div className="content-wrapper content" style={{ marginLeft: `${toggle}`, transition: "all 0.5s", paddingBottom: '45px' }} >
        <h6 style={{textAlign: 'left', paddingLeft:'5px', fontSize:'smaller'}}>Mensaje para aprobar: <button onClick={() => refreshMessage()} title='Refrescar' className='btn btn-sm btn-primary'><i className="fas fa-sync-alt"></i></button> </h6>
        <table className="table table-striped" style={{fontSize:'small', textAlign: 'justify'}}>
          <thead>
            <tr>
              <th>#Id</th>
              <th>Mensaje</th>
              <th>Para</th>
              <th>F.Envío</th>
            </tr>
          </thead>
          <tbody>
            {tableMessages}
          </tbody>
        </table>

      </div>
    )
}


export default Historial
